import type { PriceSource } from '@/lib/pricing/resolve';

/** What a dealer sees in place of a price they can't order at — an item
 *  flagged "price on request" for their account, or one with no price. */
export const DEALER_NO_PRICE_LABEL = 'Contact your rep';

export function formatMoney(n: number | null | undefined): string {
  if (n === null || n === undefined) return '$$$';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(n);
}

/** Dealer-facing price: the money amount, or the contact-your-rep label. */
export function formatDealerPrice(n: number | null | undefined): string {
  if (n === null || n === undefined) return DEALER_NO_PRICE_LABEL;
  return formatMoney(n);
}

export function priceBadgeClass(source: PriceSource): string {
  switch (source) {
    case 'override':
      return 'bg-emerald-100 text-emerald-800';
    case 'tier':
      return 'bg-neutral-100 text-neutral-800';
    case 'on_request':
      return 'bg-amber-100 text-amber-800';
    case 'unpriced':
      return 'bg-neutral-100 text-neutral-400';
  }
}
